<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-in-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-in-badge">Inspiration + 2x Photo</span>

  <div class="cr-in-grid">
    <div class="cr-in-item">
      <div
        class="cr-in-dropzone"
        [appInlineMedia]="block.variables?.['Inspiration1Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'Inspiration1Image')"
      >
        <a *ngIf="block.variables?.['Inspiration1Image']; else empty1" [href]="card1ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['Inspiration1Image']" [alt]="block.variables?.['Inspiration1ImageAlt'] || ''" />
        </a>

        <ng-template #empty1>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-in-heading"
        [appInlineEdit]="block.variables?.Inspiration1Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'Inspiration1Heading')"
      ></span>

      <a class="cr-in-cta" [href]="card1CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.Inspiration1CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'Inspiration1CtaText')"
        ></span>
      </a>
    </div>

    <div class="cr-in-item">
      <div
        class="cr-in-dropzone"
        [appInlineMedia]="block.variables?.['Inspiration2Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'Inspiration2Image')"
      >
        <a *ngIf="block.variables?.['Inspiration2Image']; else empty2" [href]="card2ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['Inspiration2Image']" [alt]="block.variables?.['Inspiration2ImageAlt'] || ''" />
        </a>

        <ng-template #empty2>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-in-heading"
        [appInlineEdit]="block.variables?.Inspiration2Heading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'Inspiration2Heading')"
      ></span>

      <a class="cr-in-cta" [href]="card2CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.Inspiration2CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'Inspiration2CtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - two identical field groups, one per card -->
<div class="cr-in-edit" *ngIf="!isPreview">
  <div class="cr-in-edit-card">
    <div class="cr-in-edit-card-title">Card 1</div>

    <div class="cr-in-field-row">
      <span class="cr-in-field-label">Image</span>
      <span
        class="cr-in-toggle"
        [class.cr-in-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-in-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['Inspiration1Image'] ?? ''"
        (handleOnChange)="onChange($event, 'Inspiration1Image')"
        [placeholder]="image1Placeholder"
        variable="Inspiration1Image"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-in-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['Inspiration1Image']">
        <div class="cr-in-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-in-title">Upload image</div>
        <div class="cr-in-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-in-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['Inspiration1ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'Inspiration1ImageHref')"
        [placeholder]="image1HrefPlaceholder"
        variable="Inspiration1ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration1ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['Inspiration1ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['Inspiration1ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'Inspiration1ImageAlt')"
      [placeholder]="image1AltPlaceholder"
      [maxLength]="500"
      variable="Inspiration1ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['Inspiration1Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'Inspiration1Heading')"
      [placeholder]="heading1Placeholder"
      [maxLength]="500"
      variable="Inspiration1Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-in-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['Inspiration1CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'Inspiration1CtaLink')"
        [placeholder]="ctaLink1Placeholder"
        [maxLength]="500"
        variable="Inspiration1CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration1CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['Inspiration1CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['Inspiration1CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'Inspiration1CtaText')"
      [placeholder]="ctaText1Placeholder"
      [maxLength]="30"
      variable="Inspiration1CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-in-edit-card">
    <div class="cr-in-edit-card-title">Card 2</div>

    <div class="cr-in-field-row">
      <span class="cr-in-field-label">Image</span>
      <span
        class="cr-in-toggle"
        [class.cr-in-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-in-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['Inspiration2Image'] ?? ''"
        (handleOnChange)="onChange($event, 'Inspiration2Image')"
        [placeholder]="image2Placeholder"
        variable="Inspiration2Image"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-in-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['Inspiration2Image']">
        <div class="cr-in-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-in-title">Upload image</div>
        <div class="cr-in-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-in-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['Inspiration2ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'Inspiration2ImageHref')"
        [placeholder]="image2HrefPlaceholder"
        variable="Inspiration2ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration2ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['Inspiration2ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['Inspiration2ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'Inspiration2ImageAlt')"
      [placeholder]="image2AltPlaceholder"
      [maxLength]="500"
      variable="Inspiration2ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['Inspiration2Heading'] ?? ''"
      (handleOnChange)="onChange($event, 'Inspiration2Heading')"
      [placeholder]="heading2Placeholder"
      [maxLength]="500"
      variable="Inspiration2Heading"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-in-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['Inspiration2CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'Inspiration2CtaLink')"
        [placeholder]="ctaLink2Placeholder"
        [maxLength]="500"
        variable="Inspiration2CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'Inspiration2CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['Inspiration2CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['Inspiration2CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'Inspiration2CtaText')"
      [placeholder]="ctaText2Placeholder"
      [maxLength]="30"
      variable="Inspiration2CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
